import i18n from '../../../i18n/i18next'
import { Paths } from '../../../routes'
import { useBoundStore } from '../../../state/bound.store'
import { useRocketChatContext } from '../../rocketchat/rocketChatProvider'
import { activeNavBar } from '../navBar'
import { NavBarItem } from './navBarItem'

export const ChatNavBarItem = () => {
    const { chatView } = useRocketChatContext()
    const chatEnabled = useBoundStore((s) => s.chatEnabled)

    if (!chatEnabled) return null

    return (
        <NavBarItem
            order={1}
            id="navbarItemChat"
            onClick={() => (chatView.value = 'default')}
            label={i18n.t('navbar.chat')}
            active={activeNavBar.value === 2}
            path={Paths.rocketChat}
            icon={'Chat'}
        />
    )
}
